export const removeSpaces = (string: string | undefined) => {
  return string ? string.replace(/\s+/g, '') : '';
};
